/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".btn-star[_ngcontent-%COMP%]{color:#d9d9d9;font-size:140%;vertical-align:bottom}.active_star[_ngcontent-%COMP%]{color:#f2db13!important}"];
export { styles as styles };
